module.exports = __webpack_public_path__ + "static/media/catIntoCaudronWizard.1b646f1d.gif";